<div class="super-ejecutivo-propuesta" [class.super-ejecutivo-propuesta--decidida]="propuesta().estado !== 'pendiente'">
  <div class="super-ejecutivo-propuesta-titulo">
    <mat-icon>task_alt</mat-icon>
    <span>Propuesta: requiere tu autorización</span>
  </div>
  <app-super-ejecutivo-markdown [texto]="propuesta().propuesta"></app-super-ejecutivo-markdown>
  @switch (propuesta().estado) {
    @case ('pendiente') {
      <div class="super-ejecutivo-propuesta-acciones">
        <button mat-flat-button class="boton-cancelar" [disabled]="deshabilitada()" (click)="decidir.emit(false)">
          <mat-icon class="kobra-icon">close</mat-icon>Rechazar
        </button>
        <button mat-stroked-button class="boton-guardar" [disabled]="deshabilitada()" (click)="decidir.emit(true)">
          <mat-icon>check</mat-icon>Autorizar
        </button>
      </div>
    }
    @case ('autorizada') {
      <div class="super-ejecutivo-propuesta-decision super-ejecutivo-propuesta-decision--autorizada">
        <mat-icon>check_circle</mat-icon>Autorizada
      </div>
    }
    @case ('rechazada') {
      <div class="super-ejecutivo-propuesta-decision super-ejecutivo-propuesta-decision--rechazada">
        <mat-icon>cancel</mat-icon>Rechazada
      </div>
    }
  }
</div>
